import { Select } from 'antd';
import React, { useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import './style.css';

const SELECT_STYLES = { width: '100%' };

const LabeledSelect = ({
  labelId,
  labelDefaultMessage,
  placeholderId,
  placeholderDefaultMessage,
  onChange,
  options,
  value,
  disabled,
  multiSelect,
}) => {
  const intl = useIntl();

  const filterOption = useCallback(
    (input, option) =>
      (option?.label ?? '').toLowerCase().includes(input.toLowerCase()),
    [],
  );

  return (
    <div className="labeled-input-container">
      <div className="labeled-input-label">
        {labelId && (
          <label>
            <FormattedMessage
              id={labelId}
              defaultMessage={labelDefaultMessage || labelId}
            />
          </label>
        )}
      </div>
      <Select
        mode={multiSelect ? 'multiple' : undefined}
        style={SELECT_STYLES}
        placeholder={intl.formatMessage({
          id: placeholderId,
          defaultMessage: placeholderDefaultMessage,
        })}
        suffixIcon={false}
        options={options}
        value={value}
        disabled={disabled}
        onChange={onChange}
        optionFilterProp="label"
        filterOption={filterOption}
        notFoundContent={intl.formatMessage({
          id: 'NO_MATCHING_OPTIONS',
          defaultMessage: 'No matching options found',
        })}
      />
    </div>
  );
};

export default LabeledSelect;

<div className="flex items-center bg-white rounded-md w-full"></div>;
